<template>
	<div>
		<div class="news-title" :style="{fontSize: details.titleSize ? details.titleSize : '18px'}">
			<i class="iconfont iconanchor-full"></i>
			<div style="margin: 0 20px;">
				{{details.title}}
			</div>
			<i class="iconfont iconanchor-full"></i>
		</div>
		<div class="inner-content">
			<div v-html="details.txt">
				
			</div>
			<div class="back" @click="$router.back(-1)">
				返回列表
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		data () {
			return {
				newsId: "",
				details: {
					
				}
			}
		},
		mounted() {
			document.body.scrollTop = document.documentElement.scrollTop = 0
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../static/top_banner_2.png'
			that.newsId = this.$route.query.news_id
			that.getNewsDetails()
		},
		methods: {
			getNewsDetails() {
				let that = this
				that.$http.post({
					url: '/api/content/getContentById',
					data: {
						id: that.newsId
					}
				}).then(res => {
					if(res.code === 'S200') {
						that.details = res.data
						if(that.details.txt) {
							that.format()
						}
					}
				})
			},
			backToList() {
				this.router.back(-1)
			},
			format() {
				var html = this.details.txt
				let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
					match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
					return match;
				});
				newContent = newContent.replace(/<br[^>]*\/>/gi, '');
				newContent = newContent.replace(/\<img/gi, '<img style="width:800px;height:auto;display:inline-block;margin:10rpx auto;"');
				newContent = newContent.replace(/\<video/gi, '<video style="width:800px;height:auto;display:inline-block;margin:10rpx auto;"');
				this.details.txt = newContent
			}
		}
	}
</script>

<style lang="less" scoped>
	.news-title {
		display: flex;
		height: 80px;
		line-height: 80px;
		font-size: 13px;
		color: #922627;
		text-align: center;
		justify-content: center;
		border-bottom: 3px solid #EDD68E;
		i {
			font-size: 17px;
			color: #F8C822;
		}
	}
	.news-xinxi {
		width: 100%;
		height: 70px;
		line-height: 70px;
		display: flex;
		color: #686868;
		font-size: 11px;
	}
	.news-content {
		font-size: 12px;
		color: #333333;
		text-align: left;
		padding: 30px 0;
	}
	.news-image {
		width: 680px;
		margin: 0 auto;
	}
	.back {
		position: relative;
		margin: 30px 0;
		height: 20px;
		.back-button {
			position: absolute;
			width: 75px;
			height: 20px;
			line-height: 20px;
			font-size: 9px;
			border: 1px solid #0E40DF;
			color: #0E40DF;
			text-align: center;
			right: 28px;
			cursor: pointer;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/visit_service/hyzj_details.vue